/* global axios */
import ApiClient from '../ApiClient';

class AiBotTracesAPI extends ApiClient {
  constructor(botId) {
    super(`agent_bots/${botId}/traces`, { accountScoped: true });
  }

  get({ page, conversation_id } = {}) {
    return axios.get(this.url, { params: { page, conversation_id } });
  }
}

export default AiBotTracesAPI;
